const masterConfig = {
    state: {
        title: "State",
        singular: "State",
        description: "Manage states used across member profiles.",
        columns: [
            {
                key: "name",
                label: "State Name",
            },
            {
                key: "code",
                label: "State Code",
            },
        ],
        fields: [
            {
                name: "name",
                label: "State Name",
                type: "text",
                required: true,
            },
            {
                name: "code",
                label: "State Code",
                type: "text",
                required: true,
            },
        ],
    },

    district: {
        title: "District",
        singular: "District",
        description: "Manage districts linked with states.",
        columns: [
            {
                key: "name",
                label: "District Name",
            },
            {
                key: "state",
                label: "State",
            },
        ],
        fields: [
            {
                name: "name",
                label: "District Name",
                type: "text",
                required: true,
            },
            {
                name: "state",
                label: "State",
                type: "select",
                required: true,
                options: [
                    "Tamil Nadu",
                    "Kerala",
                    "Karnataka",
                    "Andhra Pradesh",
                    "Telangana",
                    "Puducherry",
                ],
            },
        ],
    },

    taluk: {
        title: "Taluk",
        singular: "Taluk",
        description: "Manage taluk and sub-district information.",
        columns: [
            {
                key: "name",
                label: "Taluk Name",
            },
            {
                key: "district",
                label: "District",
            },
            {
                key: "state",
                label: "State",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Taluk Name",
                type: "text",
                required: true,
            },
            {
                name: "district",
                label: "District",
                type: "select",
                required: true,
                options: [
                    "Erode",
                    "Coimbatore",
                    "Salem",
                    "Tiruppur",
                    "Namakkal",
                ],
            },
            {
                name: "state",
                label: "State",
                type: "select",
                required: true,
                options: [
                    "Tamil Nadu",
                    "Kerala",
                    "Karnataka",
                ],
            },
        ],
    },

    community: {
        title: "Community",
        singular: "Community",
        description: "Manage matrimonial community categories.",
        columns: [
            {
                key: "name",
                label: "Community Name",
            },
            {
                key: "description",
                label: "Description",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Community Name",
                type: "text",
                required: true,
            },
            {
                name: "description",
                label: "Description",
                type: "textarea",
            },
        ],
    },

    "sub-community": {
        title: "Sub Community",
        singular: "Sub Community",
        description: "Manage community sub-categories.",
        columns: [
            {
                key: "name",
                label: "Sub Community Name",
            },
            {
                key: "community",
                label: "Community",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Sub Community Name",
                type: "text",
                required: true,
            },
            {
                name: "community",
                label: "Community",
                type: "select",
                required: true,
                options: [
                    "Community 1",
                    "Community 2",
                    "Community 3",
                ],
            },
        ],
    },

    caste: {
        title: "Caste",
        singular: "Caste",
        description: "Manage caste information.",
        columns: [
            {
                key: "name",
                label: "Caste Name",
            },
            {
                key: "community",
                label: "Community",
            },
            {
                key: "subCommunity",
                label: "Sub Community",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Caste Name",
                type: "text",
                required: true,
            },
            {
                name: "community",
                label: "Community",
                type: "select",
                required: true,
                options: [
                    "Community 1",
                    "Community 2",
                ],
            },
            {
                name: "subCommunity",
                label: "Sub Community",
                type: "select",
                options: [
                    "Sub Community 1",
                    "Sub Community 2",
                ],
            },
        ],
    },

    religion: {
        title: "Religion",
        singular: "Religion",
        description: "Manage religion master values.",
        columns: [
            {
                key: "name",
                label: "Religion Name",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Religion Name",
                type: "text",
                required: true,
            },
        ],
    },

    "mother-tongue": {
        title: "Mother Tongue",
        singular: "Mother Tongue",
        description: "Manage member language preferences.",
        columns: [
            {
                key: "name",
                label: "Language",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Language Name",
                type: "text",
                required: true,
            },
        ],
    },

    education: {
        title: "Education",
        singular: "Education",
        description: "Manage education qualifications.",
        columns: [
            {
                key: "name",
                label: "Education",
            },
            {
                key: "category",
                label: "Category",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Education Name",
                type: "text",
                required: true,
            },
            {
                name: "category",
                label: "Category",
                type: "select",
                options: [
                    "School",
                    "Diploma",
                    "Under Graduate",
                    "Post Graduate",
                    "Doctorate",
                    "Professional",
                ],
            },
        ],
    },

    profession: {
        title: "Profession",
        singular: "Profession",
        description: "Manage profession categories.",
        columns: [
            {
                key: "name",
                label: "Profession",
            },
            {
                key: "category",
                label: "Category",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Profession Name",
                type: "text",
                required: true,
            },
            {
                name: "category",
                label: "Category",
                type: "select",
                options: [
                    "IT",
                    "Medical",
                    "Engineering",
                    "Finance",
                    "Government",
                    "Business",
                    "Other",
                ],
            },
        ],
    },

    occupation: {
        title: "Occupation",
        singular: "Occupation",
        description: "Manage occupation types.",
        columns: [
            {
                key: "name",
                label: "Occupation",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Occupation Name",
                type: "text",
                required: true,
            },
        ],
    },

    income: {
        title: "Annual Income",
        singular: "Annual Income",
        description: "Manage annual income ranges.",
        columns: [
            {
                key: "name",
                label: "Income Range",
            },
            {
                key: "min",
                label: "Minimum",
            },
            {
                key: "max",
                label: "Maximum",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Income Range",
                type: "text",
                required: true,
            },
            {
                name: "min",
                label: "Minimum Amount",
                type: "number",
            },
            {
                name: "max",
                label: "Maximum Amount",
                type: "number",
            },
        ],
    },

    "marital-status": {
        title: "Marital Status",
        singular: "Marital Status",
        description: "Manage member marital status.",
        columns: [
            {
                key: "name",
                label: "Marital Status",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Marital Status",
                type: "text",
                required: true,
            },
        ],
    },

    "family-type": {
        title: "Family Type",
        singular: "Family Type",
        description: "Manage family structure categories.",
        columns: [
            {
                key: "name",
                label: "Family Type",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Family Type",
                type: "text",
                required: true,
            },
        ],
    },

    "family-status": {
        title: "Family Status",
        singular: "Family Status",
        description: "Manage family status categories.",
        columns: [
            {
                key: "name",
                label: "Family Status",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Family Status",
                type: "text",
                required: true,
            },
        ],
    },

    star: {
        title: "Star / Nakshatra",
        singular: "Star",
        description: "Manage horoscope star values.",
        columns: [
            {
                key: "name",
                label: "Star",
            },
            {
                key: "tamilName",
                label: "Tamil Name",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Star Name",
                type: "text",
                required: true,
            },
            {
                name: "tamilName",
                label: "Tamil Name",
                type: "text",
            },
        ],
    },

    rasi: {
        title: "Rasi",
        singular: "Rasi",
        description: "Manage zodiac rasi values.",
        columns: [
            {
                key: "name",
                label: "Rasi",
            },
            {
                key: "tamilName",
                label: "Tamil Name",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Rasi Name",
                type: "text",
                required: true,
            },
            {
                name: "tamilName",
                label: "Tamil Name",
                type: "text",
            },
        ],
    },

    dosham: {
        title: "Dosham",
        singular: "Dosham",
        description: "Manage horoscope dosham types.",
        columns: [
            {
                key: "name",
                label: "Dosham",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Dosham Name",
                type: "text",
                required: true,
            },
        ],
    },

    height: {
        title: "Height",
        singular: "Height",
        description: "Manage height values.",
        columns: [
            {
                key: "name",
                label: "Height",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Height",
                type: "text",
                required: true,
            },
        ],
    },

    "body-type": {
        title: "Body Type",
        singular: "Body Type",
        description: "Manage body type categories.",
        columns: [
            {
                key: "name",
                label: "Body Type",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Body Type",
                type: "text",
                required: true,
            },
        ],
    },

    complexion: {
        title: "Complexion",
        singular: "Complexion",
        description: "Manage complexion categories.",
        columns: [
            {
                key: "name",
                label: "Complexion",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Complexion",
                type: "text",
                required: true,
            },
        ],
    },

    "blood-group": {
        title: "Blood Group",
        singular: "Blood Group",
        description: "Manage blood group values.",
        columns: [
            {
                key: "name",
                label: "Blood Group",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Blood Group",
                type: "text",
                required: true,
            },
        ],
    },

    country: {
        title: "Country",
        singular: "Country",
        description: "Manage country information.",
        columns: [
            {
                key: "name",
                label: "Country Name",
            },
            {
                key: "code",
                label: "Country Code",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Country Name",
                type: "text",
                required: true,
            },
            {
                name: "code",
                label: "Country Code",
                type: "text",
                required: true,
            },
        ],
    },

    city: {
        title: "City",
        singular: "City",
        description: "Manage city and location information.",
        columns: [
            {
                key: "name",
                label: "City Name",
            },
            {
                key: "district",
                label: "District",
            },
            {
                key: "state",
                label: "State",
            },
        ],
        fields: [
            {
                name: "name",
                label: "City Name",
                type: "text",
                required: true,
            },
            {
                name: "district",
                label: "District",
                type: "select",
                options: [
                    "Erode",
                    "Coimbatore",
                    "Salem",
                    "Tiruppur",
                    "Namakkal",
                ],
            },
            {
                name: "state",
                label: "State",
                type: "select",
                options: [
                    "Tamil Nadu",
                    "Kerala",
                    "Karnataka",
                ],
            },
        ],
    },

    "branch-staff": {
        title: "Branch Staff",
        singular: "Branch Staff",
        description: "Manage branch staff members.",
        columns: [
            {
                key: "name",
                label: "Staff Name",
            },
            {
                key: "branch",
                label: "Branch",
            },
            {
                key: "mobile",
                label: "Mobile",
            },
        ],
        fields: [
            {
                name: "name",
                label: "Staff Name",
                type: "text",
                required: true,
            },
            {
                name: "branch",
                label: "Branch",
                type: "select",
                options: [
                    "Erode Main Branch",
                    "Coimbatore Branch",
                    "Salem Branch",
                    "Tiruppur Branch",
                    "Namakkal Branch",
                ],
                required: true,
            },
            {
                name: "mobile",
                label: "Mobile Number",
                type: "text",
                required: true,
            },
        ],
    },
};

export default masterConfig;